export function handleBackForwardCacheDomState() {
  window.addEventListener('pageshow', (ev) => {
    if(ev.persisted) {
      hideElementsOnPageTransition();
      showElementsOnPageTransition();
      removeElementsOnPageTransition();
    }
  });
}

function hideElementsOnPageTransition() {
  document.querySelectorAll("[data-hide-on-page-transition='true']").forEach((e) => {
    e.classList.add('hidden');
  });
}

function showElementsOnPageTransition() {
  document.querySelectorAll("[data-show-on-page-transition='true']").forEach((e) => {
    e.classList.remove('hidden');
  });
}

function removeElementsOnPageTransition() {
  document.querySelectorAll("[data-remove-on-page-transition='true']").forEach((e) => {
    e.classList.remove('hidden');
  });
}
